// Reducer
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
// State
import {
  ApplicationUtilitiesState,
  featureKey as applicationUtilitiesKey,
} from '@store/swagger/applicationUtilities/combiner';
import { AuthenticationsState, featureKey as authenticationsKey } from '@store/swagger/authentications/combiner';
import { CatalogState, featureKey as catalogKey } from '@store/swagger/catalog/combiner';
import { featureKey as policyKey, PolicyState } from '@store/swagger/policy/combiner';
import { featureKey as projectKey, ProjectState } from '@store/swagger/project/combiner';
import { projectFlowDataKey, ProjectFlowDataState, projectReducer } from '@store/flow-data/project';
import { policyFlowDataKey, PolicyFlowDataState, policyReducer } from '@store/flow-data/policy';
import { renewalFlowDataKey, RenewalFlowDataState, renewalReducer } from '@store/flow-data/renewal';
import {
  policyCancellationFlowDataKey,
  PolicyCancellationFlowDataState,
  policyCancellationReducer,
} from '@store/flow-data/policy-cancellation';
import { generalFlowDataKey, GeneralFlowDataState, generalReducer } from '@store/flow-data/general';
import { configuratorFlowDataKey, ConfiguratorFlowDataState, configuratorReducer } from '@store/flow-data/configurator';
import { localStorageSync } from 'ngrx-store-localstorage';

// Effects

// tslint:disable-next-line: no-any
const reducers: ActionReducerMap<any> = {
  [projectFlowDataKey]: projectReducer,
  [policyFlowDataKey]: policyReducer,
  [generalFlowDataKey]: generalReducer,
  [configuratorFlowDataKey]: configuratorReducer,
  [policyCancellationFlowDataKey]: policyCancellationReducer,
  [renewalFlowDataKey]: renewalReducer,
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    storage: sessionStorage,
    keys: [projectFlowDataKey, policyFlowDataKey, generalFlowDataKey, configuratorFlowDataKey],
    rehydrate: true,
  })(reducer);
}

export const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer];

const effects = [];

export interface AppState {
  [applicationUtilitiesKey]: ApplicationUtilitiesState;
  [authenticationsKey]: AuthenticationsState;
  [catalogKey]: CatalogState;
  [policyKey]: PolicyState;
  [projectKey]: ProjectState;
  [projectFlowDataKey]: ProjectFlowDataState;
  [policyFlowDataKey]: PolicyFlowDataState;
  [policyCancellationFlowDataKey]: PolicyCancellationFlowDataState;
  [generalFlowDataKey]: GeneralFlowDataState;
  [renewalFlowDataKey]: RenewalFlowDataState;
  [configuratorFlowDataKey]: ConfiguratorFlowDataState;
}

export { reducers, effects };
